export default () => {
  const spinner = document.querySelector('.spinner')

  return {
    toggle () {
      spinner.classList.toggle('opacity-0')
      spinner.classList.toggle('pointer-events-none')
    },

    enable () {
      spinner.classList.remove('opacity-0')
      spinner.classList.remove('pointer-events-none')
    },

    disable () {
      spinner.classList.add('opacity-0')
      spinner.classList.add('pointer-events-none')
    }
  }
}
